import {
  Check,
  ErrorRounded,
  ContentCopy,
  ExpandLess,
  ExpandMore,
} from "@mui/icons-material";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  Box,
  CircularProgress,
  Collapse,
  Modal,
  Snackbar,
} from "@mui/material";
import { memo, useEffect, useMemo, useRef, useState } from "react";
import { getPaymentChannelBilling } from "../../../services/paymentApi";
import { FaChevronLeft } from "react-icons/fa";
import {
  getBillingPaymentDetail,
  getBillingPaymentOptionsPbf,
  getBillingPaymentPbfDetail,
  payTransferManualBilling,
  setPaymentBilling,
  setPaymentBillingPbf,
} from "../../../services/billingAPI";
import OlinLogo from "../../../assets/icons/olinlogo.png";
import moment from "moment";
import { IoCloudUploadOutline } from "react-icons/io5";
import { uploadImage } from "../../../services/InventoryAPI";
import { LuImagePlus } from "react-icons/lu";
import { MdCancel } from "react-icons/md";
import ErrorPopup from "../../common/particles.jsx/ErrorPopup";
import toIDR from "../../hooks/toIDR";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1200,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const SubPaymentOption = ({
  paymentOption,
  setPaymentOption,
  sectionTitle,
  arr,
}) => {
  return (
    <>
      <p className="font-bold text-[14px] mb-2">{sectionTitle}</p>

      {arr.map((item) => {
        return (
          <div
            className={`w-full hover:bg-slate-100 flex py-3 px-2 justify-between rounded-md cursor-pointer items-center ${
              paymentOption && item.id === paymentOption.id
                ? "bg-slate-100"
                : ""
            }`}
            onClick={() => setPaymentOption(item)}
          >
            <div className="w-full flex items-center">
              <img src={item.logo} className="w-[48px] object-contain mr-3" />
              <p>{item.pg_bank}</p>
            </div>
            <div className="w-fit">
              {paymentOption && item.id === paymentOption.id ? (
                <Check className="text-blue-500" />
              ) : null}
            </div>
            <hr />
          </div>
        );
      })}
    </>
  );
};

const ManualSubPaymentOption = ({
  paymentOption,
  setPaymentOption,
  sectionTitle,
  arr,
  fileRef,
  setErrorMessage,
  imageArr,
  setImageArr,
  isLoadingImage,
  total,
}) => {
  return (
    <div className="mb-4">
      <p className="font-bold text-[14px] mb-2">{sectionTitle}</p>
      {arr.map((item) => {
        return (
          <div
            className={`w-full hover:bg-slate-100 py-2 px-2 mb-2 rounded-md cursor-pointer ${
              paymentOption &&
              !paymentOption.id &&
              item.bank === paymentOption.bank
                ? "bg-slate-100"
                : ""
            }`}
            onClick={() => setPaymentOption(item)}
          >
            <div className="flex justify-between items-center">
              <div className="w-full flex gap-3 items-center">
                <img src={item.logo} className="w-[48px] object-contain" />
                <p>Transaksi Manual via {item.bank}</p>
              </div>

              <div className="w-fit">
                {paymentOption &&
                !paymentOption.id &&
                item.bank === paymentOption.bank ? (
                  <Check className="text-blue-500" />
                ) : null}
              </div>
            </div>
            {paymentOption &&
            !paymentOption.id &&
            item.bank === paymentOption.bank ? (
              <div>
                <div className="flex items-center gap-2 bg-blue-200 p-2 mt-2 rounded-md mb-2">
                  <img src={item.logo} className="w-[56px] object-contain" />
                  <div className="w-full font-bold">
                    <p className="">{item.name}</p>
                    <p id="manualNum">{item.number}</p>
                  </div>
                  <ContentCopy
                    className="cursor-pointer hover:text-gray-300"
                    onClick={() => {
                      navigator.clipboard.writeText(
                        document.getElementById("manualNum").innerHTML,
                      );
                      setErrorMessage("Nomor rekening tersalin");
                    }}
                  />
                </div>

                <div className="flex items-center w-full mb-4">
                  <ErrorRounded className="mx-2 text-amber-500" />
                  <div className="w-full">
                    <p>
                      Pastikan nomor rekening yang kamu masukan benar. OLIN{" "}
                      <b>Tidak Bertanggung Jawab</b> jika terjadi kesalahan
                      pengisian data.
                    </p>
                  </div>
                </div>

                <div className="flex w-full items-center justify-between mb-4">
                  <p className="w-full text-[14px]">Tagihan Kamu</p>
                  <p className="w-full text-right font-bold text-xl">
                    {toIDR(total)}
                  </p>
                </div>

                <div className="w-full h-[200px] overflow-y-auto rounded-md border-2 border-blue-500 border-dashed bg-white flex items-center justify-center">
                  {imageArr.length === 0 ? (
                    <div
                      className="flex flex-col items-center justify-center w-full h-full  cursor-pointer hover:text-gray-400"
                      onClick={() => fileRef.current.click()}
                    >
                      {isLoadingImage ? (
                        <CircularProgress size={20} />
                      ) : (
                        <div className="flex justify-center flex-col items-center">
                          <IoCloudUploadOutline className="text-[48px]" />
                          <p>Unggah bukti pembayaran anda disini</p>
                          <p className="text-gray-500 text-[10px]">
                            Menerima file PDF, JPG, JPEG, PNG
                          </p>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="flex gap-2 items-center flex-wrap justify-center relative">
                      {imageArr.map((image, i) => (
                        <div className="relative">
                          <img
                            className="w-[100px] h-[100px] rounded-md object-cover"
                            src={image}
                          />
                          <MdCancel
                            className="text-red-500 cursor-pointer hover:text-gray-300 absolute -top-2 -right-2 text-[20px] bg-white rounded-full"
                            onClick={() => {
                              setImageArr([
                                ...imageArr.slice(0, i),
                                ...imageArr.slice(i + 1),
                              ]);
                            }}
                          />
                        </div>
                      ))}
                      <div
                        className="w-[100px] h-[100px] rounded-md border-2 border-dashed cursor-pointer hover:bg-gray-100 p-4 flex justify-center items-center"
                        onClick={() => fileRef.current.click()}
                      >
                        {isLoadingImage ? (
                          <CircularProgress size={20} />
                        ) : (
                          <LuImagePlus className="w-full h-full" />
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
};

const ModalPaymentStatus = ({ open, setOpen, bill, refetchList, isPbf }) => {
  const fileRef = useRef(null);

  const [paymentOption, setPaymentOption] = useState(null);
  const [tempStatus, setTempStatus] = useState([]);
  const [isPressed, setIsPressed] = useState(false);
  const [countdownSeconds, setCountdownSeconds] = useState(0);
  const [countdownMinutes, setCountdownMinutes] = useState(0);
  const [countdownHours, setCountdownHours] = useState(0);
  const [timeDiff, setTimeDiff] = useState(moment.duration());
  const [collapsePrice, setCollapsePrice] = useState(true);
  const [collapsePo, setCollapsePo] = useState(true);
  const [imageArr, setImageArr] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  const changeHour = () => {
    setCountdownMinutes(59);
    if (countdownHours > 0) setCountdownHours(countdownHours - 1);
  };

  const handleClose = () => {
    if (refetchList) refetchList();
    setPaymentOption(null);
    setOpen(false);
    setImageArr([]);
  };

  const handleConfirm = () => {
    if (paymentOption !== null) {
      if (isPbf) {
        const body = {
          billing_uids: bill.map((item) => item.billing_uid),
          payment_channel_id: paymentOption.id ? paymentOption.id : 0, // if manual 0
          payment_manual_bank: paymentOption.id ? "" : paymentOption.bank, // if not manual, empty string
          attachment: imageArr,
        };
        mutateBill(body);
      } else if (paymentOption.id) {
        // if not manual tf
        const body = {
          billings: bill.map((item) =>
            bill.length === 1 && bill[0].payment && bill[0].payment.total // from detail
              ? {
                  bill_id: bill[0].billing_id,
                  price: bill[0].payment.total,
                }
              : {
                  bill_id: item.billing_id,
                  price: item.total_amount,
                },
          ),
          handling_fee: paymentOption.bank_fee,
          total_price:
            (bill
              ? bill.length === 1 && bill[0].payment && bill[0].payment.total // from detail
                ? bill[0].payment.total
                : bill.reduce((acc, curVal) => acc + curVal.total_amount, 0)
              : 0) + paymentOption.bank_fee,
          payment: {
            pg_name: paymentOption.pg_name,
            pg_bank: paymentOption.pg_bank,
            pg_code: paymentOption.pg_code,
            pg_type: paymentOption.pg_type,
          },
        };
        mutateBill(body);
      } else {
        // manual tf
        const body = {
          billings: bill.map((item) =>
            bill.length === 1 && bill[0].payment && bill[0].payment.total // from detail
              ? {
                  bill_id: bill[0].billing_id,
                  price: bill[0].payment.total,
                }
              : {
                  bill_id: item.billing_id,
                  price: item.total_amount,
                },
          ),
          attachment: imageArr,
          bank: paymentOption.bank,
        };

        mutateTransferManual(body);
      }
    }
  };

  const {
    mutate: mutateBill,
    isLoading: isLoadingBill,
    data: dataBill,
  } = useMutation({
    mutationFn: isPbf ? setPaymentBillingPbf : setPaymentBilling,
    onSuccess: (data) => {
      setTempStatus([...Array(tempStatus.length).fill(2)]); // change to menunggu pembayaran
      mutateDetailPayment({
        isPbf: isPbf,
        uid: isPbf ? data.payment_uid : data.payment.va,
      });
    },
    onError: (err) =>
      setErrorMessage(err.message.id ? err.message.id : err.message),
  });

  // Tagihan PBF memakai daftarnya sendiri, yang tunduk pada penanda
  // is_pbf_billing yang diatur admin backstage. Tagihan OLIN biasa tidak ada
  // urusannya dengan penanda itu dan tetap memakai master-data.
  //
  // Daftar PBF tidak memuat blok transfer manual: metode itu berada di luar
  // allowlist dan untuk sementara ditiadakan pada tagihan PBF.
  const { data: dataPayment, isFetching: isFetchingPayment } = useQuery({
    queryFn: isPbf
      ? getBillingPaymentOptionsPbf
      : () => getPaymentChannelBilling(1),
    queryKey: ["billing-payment", open, isPbf],
    refetchOnWindowFocus: false,
    enabled: open === true && bill.every((item) => item && item.status !== 2),
  });

  const { mutate: mutateDetailPayment, data: dataDetailPayment } = useMutation({
    mutationFn: isPbf ? getBillingPaymentPbfDetail : getBillingPaymentDetail,
    onSuccess: (data) => {
      // setting countdown timer
      const timeDiffDuration = moment.duration(
        moment(isPbf ? data.expired_at : data.payment.due_date).diff(moment()),
      );
      setTimeDiff(timeDiffDuration);

      if (timeDiffDuration.hours() > 0) {
        setCountdownHours(timeDiffDuration.hours());
        setCountdownMinutes(timeDiff.minutes());
        setCountdownSeconds(timeDiff.seconds());
      }
      setIsPressed(true);
    },
  });

  const { mutate: mutateUploadImage, isLoading: isLoadingImage } = useMutation({
    mutationFn: uploadImage,
    onSuccess: (data) => {
      setImageArr([...imageArr, data]);
    },
    onError: (err) =>
      setErrorMessage(err.message.id ? err.message.id : err.message),
  });

  const { mutate: mutateTransferManual, isLoading: isLoadingTransferManual } =
    useMutation({
      mutationFn: payTransferManualBilling,
      onSuccess: (data) => {
        setTempStatus([...Array(tempStatus.length).fill(5)]); // change to menunggu konfirmasi
        mutateDetailPayment({ isPbf: isPbf, uid: data });
      },
      onError: (err) =>
        setErrorMessage(err.message.id ? err.message.id : err.message),
    });

  useEffect(() => {
    if (!isPressed) return;

    const interval = setInterval(() => {
      setCountdownSeconds((prevCount) => {
        if (prevCount === 0) {
          clearInterval(interval);
          setIsPressed(false);
          setCountdownSeconds(59);
          countdownMinutes > 0
            ? setCountdownMinutes(countdownMinutes - 1)
            : changeHour();
          return prevCount;
        }
        return prevCount - 1;
      });
      return () => clearInterval(interval);
    }, 1000);
  }, [isPressed]);

  const selectedData = useMemo(() => {
    return (bill &&
      bill.some((item) => item && (item.status === 2 || item.status === 5))) ||
      tempStatus.includes(5) ||
      tempStatus.includes(2)
      ? dataDetailPayment
      : dataBill;
  }, [dataDetailPayment]);

  const isManualFalse = useMemo(() => {
    return selectedData
      ? isPbf
        ? selectedData.attachment === undefined ||
          (selectedData.attachment && selectedData.attachment.length === 0)
        : (selectedData.is_manual ?? false) === false
      : false;
  }, [selectedData]);

  useEffect(() => {
    setIsPressed(true);
  }, [countdownMinutes, countdownHours]);

  useEffect(() => {
    if (bill) setTempStatus(bill.map((item) => (item ? item.status : 0)));
    if (
      bill &&
      bill.some((item) => item && (item.status === 2 || item.status === 5))
    ) {
      mutateDetailPayment({
        isPbf: isPbf,
        uid: isPbf
          ? bill.find(
              (item) => item && (item.status === 2 || item.status === 5),
            ).payment_uid
          : bill.find(
              (item) => item && (item.status === 2 || item.status === 5),
            ).va_number,
      });
    }
  }, [open]);

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            ...style,
            maxWidth: "75%",
            overflowY: "auto",
            overflowX: "wrap",
            height: "80vh",
            padding: 0,
            fontSize: 12,
          }}
          className="text-left text-[12px]"
        >
          <div className="sticky top-0 z-50 bg-white w-full">
            <div className="flex items-center px-8 py-4 bg-white">
              <FaChevronLeft
                className="hover:text-gray-300 cursor-pointer"
                onClick={handleClose}
              />
              <p className="text-center font-medium text-[16px] w-full">
                {bill && tempStatus
                  ? tempStatus.every((item) => item === 1 || item === 3)
                    ? "Metode Pembayaran"
                    : "Pembayaran Billing"
                  : ""}
              </p>
            </div>
            <hr />
          </div>
          {bill &&
          tempStatus &&
          tempStatus.every((item) => item === 1 || item === 3) &&
          !isLoadingBill &&
          !isLoadingTransferManual &&
          !isFetchingPayment ? (
            <>
              <div className="px-8 py-4">
                <div className="justify-center relative flex-auto object-contain">
                  {dataPayment && !isFetchingPayment ? (
                    <>
                      {/*
                        Guard on length, not truthiness: the PBF settlement list
                        sends an empty group as [] rather than null, and [] is
                        truthy — which rendered section headers with nothing
                        under them.
                      */}
                      {dataPayment.transfer_account?.length > 0 ? (
                        <ManualSubPaymentOption
                          sectionTitle={"Transaksi Manual"}
                          arr={dataPayment.transfer_account}
                          fileRef={fileRef}
                          paymentOption={paymentOption}
                          setPaymentOption={setPaymentOption}
                          setErrorMessage={setErrorMessage}
                          imageArr={imageArr}
                          setImageArr={setImageArr}
                          isLoadingImage={isLoadingImage}
                          total={
                            bill.length > 0
                              ? bill.reduce(
                                  (acc, num) =>
                                    acc +
                                    (bill.length === 1 &&
                                    bill[0].payment &&
                                    bill[0].payment.total
                                      ? num.total_transaction
                                      : isPbf
                                        ? num.total_bill
                                        : num.total_amount),
                                  0,
                                )
                              : 0
                          }
                        />
                      ) : null}
                      {dataPayment.virtual_accounts?.length > 0 ? (
                        <SubPaymentOption
                          sectionTitle={"Pembayaran Virtual Account"}
                          arr={dataPayment.virtual_accounts}
                          paymentOption={paymentOption}
                          setPaymentOption={setPaymentOption}
                        />
                      ) : null}
                      {dataPayment.emoney?.length > 0 ? (
                        <SubPaymentOption
                          sectionTitle={"Pembayaran E-Money"}
                          arr={dataPayment.emoney}
                          paymentOption={paymentOption}
                          setPaymentOption={setPaymentOption}
                        />
                      ) : null}
                      {dataPayment.credit?.length > 0 ? (
                        <SubPaymentOption
                          sectionTitle={"Pembayaran Kartu Kredit"}
                          arr={dataPayment.credit}
                          paymentOption={paymentOption}
                          setPaymentOption={setPaymentOption}
                        />
                      ) : null}
                      {dataPayment.retail?.length > 0 ? (
                        <SubPaymentOption
                          sectionTitle={"Pembayaran Via Retail"}
                          arr={dataPayment.retail}
                          paymentOption={paymentOption}
                          setPaymentOption={setPaymentOption}
                        />
                      ) : null}
                      {dataPayment.ewallet?.length > 0 ? (
                        <SubPaymentOption
                          sectionTitle={"Pembayaran E-Wallet"}
                          arr={dataPayment.ewallet}
                          paymentOption={paymentOption}
                          setPaymentOption={setPaymentOption}
                        />
                      ) : null}
                    </>
                  ) : (
                    <CircularProgress size={20} />
                  )}
                </div>
              </div>
              {dataPayment &&
              !isFetchingPayment &&
              bill &&
              tempStatus &&
              tempStatus.every((item) => item === 1 || item === 3) ? (
                <div className="w-full p-2 sticky bottom-0 z-50 bg-white">
                  <button
                    className="p-2 w-full bg-blue-500 hover:bg-gray-300 text-white rounded-md shadow-md text-[14px] disabled:bg-gray-300"
                    onClick={handleConfirm}
                    disabled={
                      isLoadingBill ||
                      isLoadingTransferManual ||
                      (paymentOption &&
                        !paymentOption.id &&
                        imageArr.length === 0)
                    }
                  >
                    Konfirmasi
                  </button>
                </div>
              ) : null}
            </>
          ) : (
            <div>
              {isLoadingBill || isFetchingPayment || isLoadingTransferManual ? (
                <div className="flex justify-center items-center px-8 py-4">
                  <CircularProgress size={15} />
                </div>
              ) : (!isPbf && dataBill) || dataDetailPayment ? (
                <>
                  <div className="px-8 py-4">
                    <div className="shadow-md rounded-xl p-3 border-2 justify-between w-full cursor-pointer">
                      <div className="flex w-full justify-start items-center mb-8">
                        <img
                          src={OlinLogo}
                          className="w-[48px] object-contain mr-4"
                        />
                        <p className="font-bold text-[14px]">Billing</p>
                      </div>

                      <div className="w-full">
                        <div
                          className="flex justify-between w-full"
                          onClick={() => setCollapsePo(!collapsePo)}
                        >
                          <div className="w-full font-bold">No. PO</div>
                          <div className="w-full text-right">
                            {collapsePo ? (
                              <ExpandLess sx={{ width: "fit-content" }} />
                            ) : (
                              <ExpandMore sx={{ width: "fit-content" }} />
                            )}
                          </div>
                          <hr className="my-2" />
                        </div>
                      </div>

                      {collapsePo ? <hr className="my-2" /> : null}

                      <div>
                        <Collapse in={collapsePo} timeout="auto" unmountOnExit>
                          <div className="my-2">
                            <div>
                              <>
                                {(dataBill && !isPbf
                                  ? dataBill.transactions_id
                                  : isPbf
                                    ? dataDetailPayment.billings
                                    : dataDetailPayment.transactions_id
                                )?.map((item, index) => {
                                  return (
                                    <div
                                      key={index}
                                      className="w-full flex justify-between"
                                    >
                                      <p
                                        className="text-blue-500"
                                        //   onClick={() =>
                                        //     navigate(
                                        //       `/billing/waiting-payment/payment-summary/${va}/detail/${item.bill_id}`
                                        //     )
                                        //   }
                                      >
                                        {item.transaction_id
                                          ? item.transaction_id
                                          : item.billing_uid}
                                      </p>
                                      <p className="basis-1/4 font-bold">
                                        {toIDR(
                                          item.amount
                                            ? item.amount
                                            : item.grand_total
                                              ? item.grand_total
                                              : 0,
                                        )}
                                      </p>
                                    </div>
                                  );
                                })}
                              </>
                            </div>
                          </div>
                        </Collapse>
                      </div>

                      <div className="w-full">
                        <div
                          className="flex justify-between w-full"
                          onClick={() => setCollapsePrice(!collapsePrice)}
                        >
                          <div className="w-full font-bold">Detail Harga</div>
                          <div className="w-full text-right">
                            {collapsePrice ? (
                              <ExpandLess sx={{ width: "fit-content" }} />
                            ) : (
                              <ExpandMore sx={{ width: "fit-content" }} />
                            )}
                          </div>
                        </div>
                      </div>

                      {collapsePrice ? <hr className="my-2" /> : null}

                      <div>
                        <Collapse
                          in={collapsePrice}
                          timeout="auto"
                          unmountOnExit
                        >
                          <div className="my-2">
                            <div className="flex justify-between w-full my-2">
                              <p>Subtotal</p>
                              <p className="basis-1/4 font-bold">
                                {toIDR(
                                  dataBill && !isPbf
                                    ? dataBill.subtotal
                                    : isPbf
                                      ? dataDetailPayment
                                        ? dataDetailPayment.grand_total
                                        : dataDetailPayment.subtotal
                                          ? dataDetailPayment.subtotal
                                          : 0
                                      : 0,
                                )}
                              </p>
                            </div>
                            <div className="flex justify-between w-full my-2">
                              <p>Tanggal Pembayaran</p>
                              <p className="basis-1/4 font-bold">
                                {selectedData?.tanggal_pembayaran
                                  ? moment(
                                      selectedData?.tanggal_pembayaran,
                                    ).format("DD MMMM YYYY")
                                  : "-"}
                              </p>
                            </div>
                            <div className="flex justify-between w-full my-2">
                              <p>Biaya Penanganan</p>
                              <p className="basis-1/4 font-bold">
                                {toIDR(
                                  dataBill && !isPbf
                                    ? dataBill.handling_fee
                                    : isPbf
                                      ? dataDetailPayment.payment_fee
                                      : dataDetailPayment.handling_fee
                                        ? dataDetailPayment.handling_fee
                                        : 0,
                                )}
                              </p>
                            </div>
                          </div>
                        </Collapse>
                      </div>

                      <hr className="my-2" />
                      <div className="w-full flex justify-between mt-2 mb-4">
                        <p className="font-bold">Total Harga</p>
                        <p className="font-bold basis-1/4">
                          {toIDR(
                            isPbf
                              ? selectedData
                                ? selectedData?.grand_total
                                : selectedData?.total
                                  ? selectedData?.total
                                  : 0
                              : 0,
                          )}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="w-full my-4">
                    <p className="text-lg font-bold mb-4 px-8">
                      Transfer {isManualFalse ? "ke Virtual Account" : "Manual"}
                    </p>
                    <div className={`bg-blue-200 px-4`}>
                      <div className="flex items-center justify-between px-8 py-4">
                        <div className="w-full flex items-center">
                          <img
                            src={
                              isPbf
                                ? selectedData?.payment_channel_logo
                                : selectedData?.payment.detail.logo
                            }
                            className="w-[56px] mr-4 object-contain"
                          />
                          <div className="font-bold">
                            <p>
                              Transfer Manual via{" "}
                              {isPbf
                                ? selectedData?.payment_channel_name
                                : selectedData?.payment.detail.pg_bank}
                            </p>
                            <p id="vaNum">
                              {isPbf
                                ? selectedData?.account_no
                                : selectedData?.payment.va}
                            </p>
                          </div>
                        </div>
                        {isManualFalse ? (
                          <div className="w-fit">
                            <ContentCopy
                              className="cursor-pointer hover:text-gray-300"
                              onClick={() => {
                                navigator.clipboard.writeText(
                                  document.getElementById("vaNum").innerHTML,
                                );
                                setErrorMessage("Nomor VA tersalin");
                              }}
                            />
                          </div>
                        ) : null}
                      </div>
                    </div>

                    {isManualFalse ? (
                      <div className="flex items-center w-full px-8 py-4">
                        <ErrorRounded className="mx-2 text-amber-500" />
                        <div className="w-full">
                          <p>
                            Pastikan nomor virtual account/pelanggan yang kamu
                            masukan benar. OLIN <b>Tidak Bertanggung Jawab</b>{" "}
                            jika terjadi kesalahan pengisian data.
                          </p>
                        </div>
                      </div>
                    ) : null}

                    <div className="w-full px-8 py-4">
                      <div className="flex items-center justify-between mb-2">
                        <p className="w-full text-[14px]">Tagihan Kamu</p>
                        <p className="w-full text-right font-bold text-xl">
                          {toIDR(
                            isPbf
                              ? selectedData
                                ? selectedData?.grand_total
                                : selectedData?.total
                                  ? selectedData?.total
                                  : 0
                              : 0,
                          )}
                        </p>
                      </div>
                      {isManualFalse ? null : (
                        <div className="flex w-full items-center justify-between">
                          <p>Status</p>
                          <p className="bg-gray-100 rounded-full py-2 px-4">
                            Menunggu Konfirmasi
                          </p>
                        </div>
                      )}
                    </div>

                    <hr className="my-4" />

                    {isManualFalse ? (
                      <div className="flex w-full items-center justify-between px-8 py-4">
                        <p className="w-full text-[14px]">Jatuh Tempo</p>
                        <div className="w-full text-right">
                          <p className="text-red-500">
                            {countdownHours > 0
                              ? countdownHours +
                                " jam " +
                                countdownMinutes +
                                " menit " +
                                countdownSeconds +
                                " detik"
                              : "Expired"}
                          </p>
                          <p>
                            Mohon lakukan pembayaran sebelum{" "}
                            {moment(
                              isPbf
                                ? selectedData?.expired_at
                                : selectedData?.payment?.due_date,
                            ).format("DD MMMM YYYY")}
                          </p>
                        </div>
                      </div>
                    ) : (
                      <div className="w-full px-8 py-4">
                        <p className="w-full text-[14px] mb-2">
                          Bukti Pembayaran
                        </p>
                        <div className="flex gap-2 flex-wrap">
                          {selectedData?.attachment?.map((image) => (
                            <img
                              src={image}
                              className="w-[150px] h-[150px] object-cover rounded-md"
                            />
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </>
              ) : null}
            </div>
          )}
        </Box>
      </Modal>

      {true && (
        <input
          ref={fileRef}
          id="dropzone-img"
          hidden
          type="file"
          accept="image/jpeg, image/png, image/jpg"
          onChange={(e) => {
            mutateUploadImage(e.target.files[0]);
            e.target.value = "";
          }}
        />
      )}

      <ErrorPopup
        errorMessage={errorMessage}
        setErrorMessage={setErrorMessage}
      />
    </>
  );
};

export default ModalPaymentStatus;
